"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _definitionhelpers = require("../../../utils/definitionhelpers");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */

/* ++++++++++ --------------- INLINEMESSAGE : DEFINITION --------------- ++++++++++ */


var _default2 = {
  name: 'InlineMessage',
  group: _definitionhelpers.groupNames.messages,
  props: {
    name: {
      type: 'string',
      default: 'headercode'
    },
    variant: {
      type: 'string',
      default: 'neutral',
      options: ['neutral', 'primary', 'secondary', 'attention', 'warning']
    },
    icon: {
      type: 'string',
      default: 'exclamation-triangle'
    },
    title: {
      type: 'string'
    },
    message: {
      type: 'object',
      default: "This is an Inline Message"
    },
    close: {
      type: 'boolean',
      default: false,
      options: [true, false]
    },
    display: {
      type: 'boolean',
      default: true,
      options: [true, false]
    },
    handleClose: {
      type: 'function',
      default: function _default() {
        return console.log('Closed');
      },
      disabled: true,
      help: _definitionhelpers.helpMessages.functions
    }
  }
};
exports.default = _default2;